<template>
  <div>
    <div class="uk-grid">
      <div class="uk-width-1-2">
        <div v-for="(group, i) in dates" :key="`date-group-${i}`">
          <select
            v-model="show_id"
            class="uk-select"
            @change="getGraph()"
            v-if="correlation_type == i"
          >
            <option
              v-for="(option, j) in group"
              :key="`group--${i}-${j}`"
              :value="option.id"
            >
              {{ option.date }} - {{ option.diff }}
            </option>
          </select>
        </div>
      </div>
      <div class="uk-width-1-6"></div>
      <div class="uk-width-1-3">
        <select v-model="correlation_type" class="uk-select">
          <option value="5-min">5 Minutes</option>
          <option value="15-min">15 Minutes</option>
          <option value="1-hour">1 Hour</option>
          <option value="4-hour">4 Hour</option>
          <option value="daily">Daily</option>
          <option value="weekly">Weekly</option>
          <option value="monthly">Monthly</option>
          <option value="6-month">6 Months</option>
          <option value="12-month">12 Months</option>
        </select>
      </div>
    </div>

    <div v-if="loaded" class="uk-margin-medium-top">
      <chart :data="graph_data" type="bar" :height="`200px`" />

      <div class="uk-grid uk-margin-medium-top">
        <div class="uk-width-1-3">
          <h5 class="uk-margin-remove">Strong</h5>
          <ul class="uk-margin-small-top">
            <li v-for="(strong, i) in analysis.strong" :key="`strong-${i}`">
              {{ strong }}
            </li>
          </ul>
        </div>
        <div class="uk-width-1-3">
          <h5 class="uk-margin-remove">Neutral</h5>
          <ul class="uk-margin-small-top">
            <li v-for="(neutral, i) in analysis.neutral" :key="`neutral-${i}`">
              {{ neutral }}
            </li>
          </ul>
        </div>
        <div class="uk-width-1-3">
          <h5 class="uk-margin-remove">Weak</h5>
          <ul class="uk-margin-small-top">
            <li v-for="(weak, i) in analysis.weak" :key="`weak-${i}`">
              {{ weak }}
            </li>
          </ul>
        </div>
      </div>
      <hr />
      <div class="uk-grid uk-margin-medium-top">
        <div class="uk-width-1-1">
          <h4>Further Analysis</h4>
          <div class="uk-overflow-auto">
            <table class="uk-table uk-table-small uk-table-middle">
              <thead>
                <tr>
                  <th></th>
                  <th>1 Hour</th>
                  <th>4 Hour</th>
                  <th>Daily</th>
                  <th>Weekly</th>
                  <th>Monthly</th>
                  <th>6 Month</th>
                  <th>12 Month</th>
                  <th>Majority</th>
                </tr>
              </thead>
              <tbody>
                <tr class="correlation strong">
                  <td>Strong</td>
                  <td v-for="(value, key) in table" :key="`table-${key}`">
                    <p
                      v-for="(item, i) in value['strong']"
                      :key="`table-${key}-${i}`"
                    >
                      {{ item }}
                    </p>
                  </td>
                  <td>{{ majority_strong }}</td>
                </tr>
                <tr class="correlation neutral">
                  <td>Neutral</td>
                  <td v-for="(value, key) in table" :key="`table-${key}`">
                    <p
                      v-for="(item, i) in value['neutral']"
                      :key="`table-${key}-${i}`"
                    >
                      {{ item }}
                    </p>
                  </td>
                  <td>{{ majority_neutral }}</td>
                </tr>
                <tr class="correlation weak">
                  <td>Weak</td>
                  <td v-for="(value, key) in table" :key="`table-${key}`">
                    <p
                      v-for="(item, i) in value['weak']"
                      :key="`table-${key}-${i}`"
                    >
                      {{ item }}
                    </p>
                  </td>
                  <td>{{ majority_weak }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!loaded">
      <div uk-spinner></div>
    </div>
  </div>
</template>

<script>
import Chart from "./Chart";

export default {
  components: { Chart },

  mounted() {
    this.fetch();
  },

  data() {
    return {
      show_id: 0,
      dates: [],
      loaded: false,
      graph_data: {},
      correlation_type: "1-hour",
      analysis: {},
      table: {},
    };
  },

  methods: {
    fetch() {
      this.$loader.start();

      this.$axios.get("/api/v1/trader/correlation").then((response) => {
        this.dates = response.data.dates;
        this.table = response.data.analysis;
        this.show_id = response.data.dates["1-hour"][0].id;
        this.$loader.stop();
      });
    },

    getGraph() {
      this.loaded = false;

      this.$axios
        .get(`/api/v1/trader/correlation/${this.show_id}`)
        .then((response) => {
          this.graph_data = response.data.graph_data;
          this.analysis = response.data.analysis;
          this.loaded = true;
        });
    },
  },

  computed: {
    majority_strong() {
      let arr = [];

      this.table.forEach((col) => {
        if (col["strong"]) {
          col["strong"].forEach((cur) => {
            if (arr[cur]) {
              arr[cur] += 1;
            } else {
              arr[cur] = 1;
            }
          });
        }
      });

      let sort = Object.values(arr).sort((a, b) => {
        return b - a;
      });
      let sorted = Object.values(arr).indexOf(sort[0]);

      return Object.keys(arr)[sorted];
    },

    majority_neutral() {
      let arr = [];

      this.table.forEach((col) => {
        if (col["neutral"]) {
          col["neutral"].forEach((cur) => {
            if (arr[cur]) {
              arr[cur] += 1;
            } else {
              arr[cur] = 1;
            }
          });
        }
      });

      let sort = Object.values(arr).sort((a, b) => {
        return b - a;
      });
      let sorted = Object.values(arr).indexOf(sort[0]);

      return Object.keys(arr)[sorted];
    },

    majority_weak() {
      let arr = [];

      this.table.forEach((col) => {
        if (col["weak"]) {
          col["weak"].forEach((cur) => {
            if (arr[cur]) {
              arr[cur] += 1;
            } else {
              arr[cur] = 1;
            }
          });
        }
      });

      let sort = Object.values(arr).sort((a, b) => {
        return b - a;
      });
      let sorted = Object.values(arr).indexOf(sort[0]);

      return Object.keys(arr)[sorted];
    },
  },

  watch: {
    show_id() {
      this.getGraph();
    },

    correlation_type(newval) {
      if (this.dates[newval]) {
        this.show_id = this.dates[newval][0].id;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.correlation,
.correlation p {
  color: #404040 !important;
}

.correlation.strong {
  background: #2c994a;
}

.correlation.neutral {
  background: yellow;
}

.correlation.weak {
  background: #ed1c25;
}
</style>
